import type { ThemeOptions } from '@mui/material'

export const commonPaletteColors: NonNullable<
  ThemeOptions['palette']
>['common'] = {
  white: '#FFFFFF',
  black: '#000000',
}
